// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"styles_avatarWrapper__bBGlj","avatar":"styles_avatar__FM+6H","name":"styles_name__9qpSt","avatarWrapperSmall":"styles_avatarWrapperSmall__cgQMn"};